import { RemoteListUsersOnlinePlatform } from 'data/usecases/dashboard';
import { ListUsersOnlinePlatform } from 'domain/usecases/dashboard';
import { makeApiUrlUsersOnlinePlatform } from 'main/factories/http/api-url-factory';
import { makeAxiosHttpClient } from 'main/factories/http/axios-http-client-factory';

export const makeOnlineUsersPlatform = (): ListUsersOnlinePlatform =>
  new RemoteListUsersOnlinePlatform(
    makeApiUrlUsersOnlinePlatform(),
    makeAxiosHttpClient(),
  );
